import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TextInput } from "../index";

export const TextField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
            <TextInput key={field.name} name={field.name} label={field.translationKeys.label} readOnly={readOnly} />
        </Form.Item>
    );
};
